import React, { useEffect, useRef, useState } from "react";

/**
 * Sticky mobile CTA ; Zone H.
 * Appears only after `triggerRef` scrolls out of view.
 */
export default function StickyMobileCTA({ triggerRef, label, onClick, testId }) {
  const [show, setShow] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!triggerRef?.current) return;
    observerRef.current = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );
    observerRef.current.observe(triggerRef.current);
    return () => observerRef.current?.disconnect();
  }, [triggerRef]);

  return (
    <div className={`sticky-cta ${show ? "show" : ""}`} data-testid={testId || "sticky-cta"}>
      <button onClick={onClick} className="btn-primary" data-testid={`${testId || "sticky-cta"}-button`}>
        {label}
      </button>
    </div>
  );
}
